export default "__VITE_ASSET__vJn3LCWC__"